import React from 'react';

import { H4 } from '@zooplus/ui-components';

import styles from './AmountLabel.module.scss';

interface AmountLabelProps {
  amount: number;
  currency: string;
  amountFormatted: string;
}

export const AmountLabel: React.FC<AmountLabelProps> = (props: AmountLabelProps) => {

  return (
    <span className={styles.amountLabelWrapper}>
      <H4 className={styles.amount}>{props.amountFormatted}</H4>
    </span>
  );
};
